import { Events } from "@auvious/utils";
import { log } from "./utils";
export class SinkEffect {
    constructor() {
        this.name = "auvious.media-sink";
        this.events = new Events();
        this.outputs = [];
    }
    setSink(sink) {
        this.sink = sink;
        // const print = (...args: any[]) =>
        //   log("video event", this.sink?.readyState, ...args);
        // this.sink.addEventListener("playing", (event) => {
        //   print(event.type);
        // });
        // this.sink.addEventListener("waiting", (event) => {
        //   print(event.type);
        // });
        // this.sink.addEventListener("loadedmetadata", (event) => {
        //   print(event.type);
        // });
        // this.sink.addEventListener("loadeddata", (event) => {
        //   print(event.type);
        // });
        // this.sink.addEventListener("canplay", (event) => {
        //   print(event.type);
        // });
        // this.sink.addEventListener("canplaythrough", (event) => {
        //   print(event.type);
        // });
        // this.sink.addEventListener("play", (event) => {
        //   print(event.type);
        // });
        // this.sink.addEventListener("pause", (event) => {
        //   print(event.type);
        // });
        // this.sink.addEventListener("suspend", (event) => {
        //   print(event.type);
        // });
        // this.sink.addEventListener("stalled", (event) => {
        //   print(event.type);
        // });
        this.sink.autoplay = true;
        this.sink.muted = true;
        this.sink.volume = 0;
        if (this.streamIn) {
            this.setInput(this.streamIn);
        }
    }
    unsetSink() {
        if (this.sink) {
            this.sink.srcObject = null;
            this.sink = undefined;
        }
    }
    /** copy new tracks to the output mediastream, audio is ignored to avoid hearing ourselves */
    setInput(source) {
        var _a, _b;
        var _c;
        if (!this.sink) {
            this.streamIn = source;
            return;
        }
        if (this.sink instanceof HTMLVideoElement) {
            log("(re)set sink stream to", source);
            const current = source.getVideoTracks()[0];
            const previous = (_a = this.sink.srcObject) === null || _a === void 0 ? void 0 : _a.getVideoTracks()[0];
            (_b = (_c = this.sink).srcObject) !== null && _b !== void 0 ? _b : (_c.srcObject = new MediaStream());
            if (current !== previous) {
                if (previous) {
                    log("removing video track from output stream", previous);
                    this.sink.srcObject.removeTrack(previous);
                }
                if (current && current.readyState !== "ended") {
                    log("adding video track to output stream", current);
                    this.sink.srcObject.addTrack(current);
                }
            }
        }
        this.output((this.streamIn = source));
    }
    onOutput(callback) {
        this.outputs.push(callback);
    }
    output(stream) {
        var _a, _b;
        let current = stream.getAudioTracks()[0];
        let previous = (_a = this.streamOut) === null || _a === void 0 ? void 0 : _a.getAudioTracks()[0];
        if (current !== previous) {
            this.events.emit("tracks", { previous, current, kind: "audio" });
        }
        current = stream.getVideoTracks()[0];
        previous = (_b = this.streamOut) === null || _b === void 0 ? void 0 : _b.getVideoTracks()[0];
        if (current !== previous) {
            this.events.emit("tracks", { previous, current, kind: "video" });
        }
        this.outputs.forEach((callback) => callback(stream));
        this.streamOut = stream;
    }
}
